import React, { useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useTable } from "react-table";
import axios from "axios";
import * as XLSX from "xlsx";

import {
  clearCheckedLists,
  AddOptionToString,
  ResetCustomerData,
  isNull,
  ResetCustomerLineData,
} from "../../../components/common/Common";

function CustomerSearchResult({
  varColumnLists,
  varTotalCount,
  varMaxNumPage,
  varCustomerLists,
  setCustomerLists,
  getCustomerList,
  excelData,
}) {
  let admin_idx = 0;
  if (!isNull(localStorage.getItem("adminIdx")))
    admin_idx = Number(localStorage.getItem("adminIdx"));

  //console.log(varColumnLists,varCustomerLists);
  //excel 파일
  const fileRef1 = useRef();
  const fileRef2 = useRef();

  const [varExcelProgress, setExcelProgress] = useState(false);

  //컬럼 - 제목부
  const columns = useMemo(() => {
    if (varColumnLists?.length > 0) return varColumnLists;
    // eslint-disable-next-line
  }, []);

  //표시할 정보
  const data = useMemo(() => {
    if (varCustomerLists?.length > 0) return varCustomerLists;
    // eslint-disable-next-line
  }, [varCustomerLists]);

  //initialState:{hiddenColumns:["data22"]} <-- 컬럼 숨기기
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
      initialState: { hiddenColumns: ["data10", "data11"] },
    });

  //목록의 모든 항목 선택하기
  const onCheckedAll = (e) => {
    const bChecked = Number(e.currentTarget.checked);
    clearCheckedLists(bChecked);
    //배열값 변경
    let copyDatas = [...varCustomerLists];
    for (var i = 0; i < copyDatas.length; i++) {
      copyDatas[i].data11 = bChecked;
    }
    setCustomerLists(copyDatas);
  };

  //목록상의 항목 선택하기
  const onCheckedElement = (e, cs_idx) => {
    const bChecked = Number(e.currentTarget.checked);
    const findIndex = varCustomerLists.findIndex(
      (element) => element.data10 === cs_idx
    );
    //console.log(varCustomerLists,findIndex,cs_idx);
    let copyLists = [...varCustomerLists];
    copyLists[findIndex].data11 = bChecked;
    setCustomerLists(copyLists);
    CheckAllButtonState();
  };
  //전체선택항목 조정
  const CheckAllButtonState = () => {
    //전체버튼 점검
    let bchecked = true;
    const delItems = document.querySelectorAll(".del-item");
    for (var i = 0; i < delItems.length; i++) {
      if (delItems[i].checked === false) {
        bchecked = false;
        break;
      }
    }
    const chkallItem = document.getElementById("deleteItems");
    chkallItem.checked = bchecked;
  };

  //EXCEL--------------------------------------------------------------------------------------
  //엑셀 다운로드
  const onDownloadExcelHandler = (e) => {
    if (!window.confirm("Excel 파일로 다운로드합니까?")) return false;

    //엑셀자료 만들기
    let excelList = [];
    for (let i = 0; i < excelData.length; i++) {
      const item = excelData[i];
      const newExcelObj = { 번호: i + 1 }; // 번호 추가
      for (let j = 0; j < varColumnLists.length; j++) {
        const column = varColumnLists[j];
        newExcelObj[column.Header] = item[column.accessor] || "";
      }
      excelList.push(newExcelObj);
    }

    const ws = XLSX.utils.json_to_sheet(excelList);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "거래처현황");
    XLSX.writeFileXLSX(wb, "더나은물류-거래처현황관리.xlsx");

    // 체크박스 선택 상태 초기화
    const resetCustomerLists = varCustomerLists.map((row) => ({
      ...row,
      data11: 0,
    }));
    setCustomerLists(resetCustomerLists);
    clearCheckedLists(false);
  };

  //엑셀파일을 선택하기
  const onUploadExcelHandler = (e, ino) => {
    if (ino === 1) fileRef1.current.click();
    else fileRef2.current.click();
  };
  //엑셀파일을 읽어오기
  const onSelectedFileHandler = (e, ino) => {
    let fileBox = fileRef1.current;
    if (ino === 2) fileBox = fileRef2.current;
    setExcelProgress(true);
    if (fileBox.value === "" || !fileBox.files) return false;
    const file = fileBox.files[0];
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    fileReader.onload = (e) => {
      if (!e.target) {
        setExcelProgress(false);
        return;
      }
      const bufferArray = e.target.result;
      const fileInformation = XLSX.read(bufferArray, {
        type: "buffer",
        cellText: false,
        cellDates: true,
      });
      const sheetName = fileInformation.SheetNames[0];
      const rawData = fileInformation.Sheets[sheetName];
      const datas = XLSX.utils.sheet_to_json(rawData);
      //console.log(datas);
      if (datas?.length === 0) {
        setExcelProgress(false);
        alert("읽어들일 정보가 존재하지 않습니다. 다른 파일을 선택하세요.");
        return false;
      }
      if (ino === 1) ReadExcelFileCustomerData(datas);
      else ReadExcelFileCustomerLineData(datas);
    };
  };

  //읽어드린 엑셀파일정보 재가공 ---- 거래처
  const ReadExcelFileCustomerData = async (datas) => {
    let sendArray = [];
    console.log(datas);
    for (var i = 0; i < datas.length; i++) {
      let sendData = ResetCustomerData(datas[i]);
      //운전자, 거래처
      if (!isNull(sendData["cs_name"])) {
        await axios
          .post(
            `${process.env.REACT_APP_HOST}/_get_customer_exceldata`,
            sendData
          )
          .then((res) => {
            const datas = res.data;
            if (datas.retvalue === 1) {
              sendData["cs_idx"] = datas.cs_idx;
            } else {
              sendData["cs_idx"] = 0;
            }
          });
        sendData["cs_mem_idx"] = admin_idx;
        sendArray.push(sendData);
      }
    }
    RegisterExcelFileCustomerData(sendArray);
  };
  //DB에 저장하기
  const RegisterExcelFileCustomerData = async (sendArray) => {
    for (var i = 0; i < sendArray.length; i++) {
      const sendData = { dataInfo: sendArray[i] };
      const res = await axios.post(
        `${process.env.REACT_APP_HOST}/_register_customer`,
        sendData
      );
      console.log(i, res);
    }
    alert("거래처의 등록이 완료되었습니다.");
    setExcelProgress(false);
    window.location.reload();
  };

  //읽어드린 엑셀파일정보 재가공 ---- 거래처 라인-------------------------------------------------
  const ReadExcelFileCustomerLineData = async (datas) => {
    let sendArray = [];
    console.log(datas);
    let noExistCustomerArray = [];
    for (var i = 0; i < datas.length; i++) {
      let sendData = ResetCustomerLineData(datas[i]);
      //운전자, 거래처
      if (!isNull(sendData["cs_name"])) {
        console.log(sendData);
        await axios
          .post(
            `${process.env.REACT_APP_HOST}/_get_customer_line_exceldata`,
            sendData
          )
          .then((res) => {
            const datas = res.data;
            console.log(datas);
            if (datas.retvalue === 1) {
              sendData["cs_idx"] = datas.cs_idx; //거래처번호
              console.log(sendData);
              sendArray.push(sendData);
            } else {
              noExistCustomerArray.push(sendData["cs_name"]);
            }
          });
      }
    }
    RegisterExcelFileCustomerLineData(sendArray, noExistCustomerArray);
  };
  //DB에 저장하기
  const RegisterExcelFileCustomerLineData = async (
    sendArray,
    noExistCustomerArray
  ) => {
    if (sendArray?.length === 0) {
      setExcelProgress(false);
      alert(
        "읽어온 정보상의 거래처들이 미등록 상태이므로 라인을 등록할 수 없습니다."
      );
      return false;
    }
    let noExistCustomers = "";
    if (noExistCustomerArray?.length > 0)
      noExistCustomers = noExistCustomerArray.join(",");
    for (var i = 0; i < sendArray.length; i++) {
      const sendData = { dataInfo: sendArray[i] };
      const res = await axios.post(
        `${process.env.REACT_APP_HOST}/_register_customer_line`,
        sendData
      );
      console.log(i, res);
    }
    if (noExistCustomers !== "")
      alert(
        `거래처별 노선 등록이 완료되었습니다.\n등록안된 거래처 : ${noExistCustomers}`
      );
    setExcelProgress(false);
    window.location.reload();
  };

  //EXCEL--------------------------------------------------------------------------------------

  //선택 항목 삭제
  const onDeleteCustomerList = async (e) => {
    e.preventDefault();
    //삭제하기위해 선택된 항목 알아내기
    let delitems = 0;
    let boardIndexString = "";
    varCustomerLists.map((element) => {
      if (element.data11) {
        delitems++;
        boardIndexString = AddOptionToString(
          element.data10,
          boardIndexString,
          ","
        );
      }
      return "";
    });

    if (delitems === 0) {
      alert("삭제할 정보가 선택되어 있지 않습니다.");
      return;
    }
    if (!window.confirm(delitems + "개의 선택된 정보를 삭제합니까?")) return;

    const sendData = { mode: 4, delitems: boardIndexString };
    console.log(sendData);
    await axios
      .post(`${process.env.REACT_APP_HOST}/_delete_board_list`, sendData)
      .then((res) => {
        if (res.data.retvalue === 1) {
          clearCheckedLists(false);
          getCustomerList();
        } else {
          alert(res.data.message);
        }
      });
  };

  return (
    <>
      <div className="main-box" style={{ marginTop: "30px" }}>
        <div className="btn-between">
          <div>
            <button
              onClick={(e) => onUploadExcelHandler(e, 1)}
              className="btn line"
            >
              거래처 EXCEL 읽어오기
            </button>
            <input
              type="file"
              ref={fileRef1}
              onChange={(e) => onSelectedFileHandler(e, 1)}
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              style={{ display: "none" }}
            />
            <button
              onClick={(e) => onUploadExcelHandler(e, 2)}
              className="btn line"
            >
              노선 EXCEL 읽어오기
            </button>
            <input
              type="file"
              ref={fileRef2}
              onChange={(e) => onSelectedFileHandler(e, 2)}
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              style={{ display: "none" }}
            />
            {varExcelProgress ? (
              <span style={{ marginLeft: "20px" }}>작업중...</span>
            ) : null}
          </div>
          <div>
            <span>검색건수 : {varTotalCount} 건</span>&nbsp;&nbsp;
            <Link to={`/Admin/CustomerDetail/0`} className="btn-danger">
              거래처등록
            </Link>
            <button
              onClick={(e) => onDeleteCustomerList(e)}
              className="btn line"
            >
              거래처삭제
            </button>
            <button
              onClick={(e) => onDownloadExcelHandler(e)}
              className="btn line"
            >
              EXCEL 다운로드
            </button>
          </div>
        </div>
        <div className="scroll-table">
          <table className="list scroll delivery" {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup, y) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  <th style={{ width: "30px" }}>
                    <input
                      type="checkbox"
                      style={{ marginLeft: "0px" }}
                      id="deleteItems"
                      onChange={(e) => onCheckedAll(e)}
                    />
                  </th>
                  <th style={{ width: "50px" }}>번호</th>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps({
                        style: { width: column.width },
                      })}
                    >
                      {column.render("Header")}
                    </th>
                  ))}
                  <th style={{ width: "90px" }}>상세</th>
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {varCustomerLists?.length === 0 ? (
                <tr>
                  <td colSpan={13}>등록된 거래처가 없습니다.</td>
                </tr>
              ) : (
                rows.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      <td className="board-list">
                        <input
                          type="checkbox"
                          className={"del-item"}
                          id={"deleteItem_"}
                          onChange={(e) =>
                            onCheckedElement(e, row.values.data10)
                          }
                        />
                      </td>
                      <td>{varMaxNumPage - i}</td>
                      {row.cells.map((cell, i) => {
                        return (
                          <td
                            {...cell.getCellProps({
                              style: { width: cell.column.width },
                            })}
                          >
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                      <td>
                        <Link
                          to={`/Admin/CustomerDetail/${row.values.data10}`}
                          style={{ width: "70px" }}
                          className="btn line black"
                        >
                          상세
                        </Link>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default CustomerSearchResult;
